<template>
  <div>
    <label>Ф.И.О пользователя</label>
    <v-autocomplete :items="users"
                    v-model="user"
                    :get-label="getLabel"
                    :component-item='template'
                    @item-selected='selectUser'
                    @update-items="searchUsers"></v-autocomplete>
  </div>
</template>

<script>
  import ItemTemplate from './autocomplete_template.vue'
  export default {
    data() {
      return {
        user: {},
        users: [],
        template: ItemTemplate
      }
    },
    props: ['url', 'customRefs'],
    methods: {
      getLabel(user) {
        if (user) return user.label
      },
      selectUser(user) {
        if (user) {
          let userIdInput = this.customRefs.user_id_input
          userIdInput.value = user.id
        }
      },
      searchUsers(query) {
        let url = `${this.url}?term=${query}`
        this.$http.get(url).then(data => {
          this.users = data.body
        })
      }
    }
  }
</script>
